export default __webpack_public_path__ + "static/media/softwaredevelopment.2093c067.jpg";